export const DELIVERY_INTERVALS = {
  EVERY_WEEK: 10,
  EVEN_WEEKS: 20,
  ODD_WEEKS: 30,
} as const;

export type DeliveryInterval =
  (typeof DELIVERY_INTERVALS)[keyof typeof DELIVERY_INTERVALS];
